import { useEffect, useRef } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App/model/app.store";
import { isParcelSearchShipmentModel } from "entities/ParcelSearchCard";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";

import { getInitialSearchQPM } from "../ParamsManager";

type UseParcelUrlQueryHandlerProps = {
  openedCard: ShipmentModel | null;
};

export const useParcelUrlQueryHandler = ({ openedCard }: UseParcelUrlQueryHandlerProps) => {
  const dispatch = useAppDispatch();
  const openedCardQPM = useRef(getInitialSearchQPM()).current;
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  const { isCurrentViewOpenedCard } = usePanelViews();

  useEffect(() => {
    if (!isCurrentViewOpenedCard) return;
    if (requestedFromUrl || !openedCard?.reference) return;

    openedCardQPM.set("number", openedCard.reference);

    if (isParcelSearchShipmentModel(openedCard)) {
      const carrier = openedCard?.carrierCode;

      if (carrier) {
        openedCardQPM.set("carrier", carrier);
      }
    }
    openedCardQPM.update();
  }, [openedCard?.rawData]);

  useEffect(
    () => () => {
      openedCardQPM.clear();
      openedCardQPM.update();
      dispatch(appStore.actions.setRequestedFromUrl(false));
    },
    []
  );
};
